// SVG - Generiques
import { ReactComponent as Altitude } from './../svg/files/picto-altitude.svg';
import { ReactComponent as Brightness } from './../svg/files/picto-brightness.svg';
import { ReactComponent as Calendar } from './../svg/files/picto-calendar.svg';
import { ReactComponent as Download } from './../svg/files/picto-download.svg';
import { ReactComponent as Eye } from './../svg/files/picto-eye.svg';
import { ReactComponent as FullScreen } from './../svg/files/picto-fullscreen.svg';
import { ReactComponent as Light } from './../svg/files/picto-light.svg';
import { ReactComponent as Moon} from './../svg/files/picto-moon.svg';
import { ReactComponent as Pause } from './../svg/files/picto-pause.svg';
import { ReactComponent as Pdf } from './../svg/files/picto-pdf.svg';
import { ReactComponent as Play } from './../svg/files/picto-play.svg';
import { ReactComponent as Rain } from './../svg/files/picto-rain.svg';
import { ReactComponent as Summer } from './../svg/files/picto-summer.svg';
import { ReactComponent as Sun } from './../svg/files/picto-sun.svg';
import { ReactComponent as Winter } from './../svg/files/picto-winter.svg';

let svgHelper = {};

//TODO: Rendre le tout dynamique, éviter de créer systématiquement une ligne par .svg

//DESC: Boutons génériques./
svgHelper['picto-altitude'] = <Altitude />;
svgHelper['picto-brightness'] = <Brightness />;
svgHelper['picto-calendar'] = <Calendar />;
svgHelper['picto-download'] = <Download />;
svgHelper['picto-eye'] = <Eye />;
svgHelper['picto-fullscreen'] = <FullScreen />;
svgHelper['picto-light'] = <Light />;
svgHelper['picto-moon'] = <Moon />;
svgHelper['picto-pause'] = <Pause />;
svgHelper['picto-pdf'] = <Pdf />;
svgHelper['picto-play'] = <Play />;
svgHelper['picto-rain'] = <Rain />;
svgHelper['picto-summer'] = <Summer />;
svgHelper['picto-sun'] = <Sun />;
svgHelper['picto-winter'] = <Winter />;

export default svgHelper;
